import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';

import { ToWords } from 'to-words';
const logo = require('../Images/FullLogo_NoBuffer__4_-removebg-preview.png');


const cleanText = (text) => {
  if (!text) return '';
  return text
    .replace(/[^\w\s\-.,]/g, '')  // Remove special chars
    .replace(/\s+/g, ' ')         // Clean spaces
    .trim()
    .substring(0, 30);           // Limit length for table
};

const styles = StyleSheet.create({
  page: {
    fontSize: 10,
    padding: 30,
    fontFamily: 'Helvetica',
    lineHeight: 1.4,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
    borderBottomWidth: 2,
    borderBottomColor: '#f0a027',
    paddingBottom: 10,
  },
  companySection: {
    flex: 2,
  },
  invoiceInfo: {
    flex: 1,
    alignItems: 'flex-end',
  },
  logo: {
    width: 120,
  },
  companyName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginTop: 5,
    marginBottom: 5,
  },
  companyDetails: {
    fontSize: 9,
    color: '#666',
    marginTop: 4,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#f0a027',
    marginVertical: 8,
  },
  table: {
    width: '100%',
    marginVertical: 5,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    alignItems: 'center',
    minHeight: 24,
  },
  tableColHeader: {
    width: '25%',
    fontWeight: 'bold',
    backgroundColor: '#f8f8f8',
    paddingVertical: 5,
    paddingHorizontal: 4,
    color: '#333',
  },
  tableCol: {
    width: '28%',
    paddingVertical: 5,
    paddingHorizontal: 4,
    color: '#444',
    flexWrap: 'wrap',      
    wordBreak: 'break-all', 
  },
  amountSection: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 15,
  },
  totalAmount: {
    width: '30%',
    border: '1',
    borderColor: '#f0a027',
    padding: 8,
    backgroundColor: '#fff9f0',
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    right: 30,
    fontSize: 8,
    color: '#666',
    textAlign: 'center',
    borderTopWidth: 1,
    borderTopColor: '#eee',
    paddingTop: 8,
  },
});

const toWords = new ToWords();
const convertToWords = (amount) => {
  if (!amount || isNaN(amount)) return 'Zero Rupees';
  let words = toWords.convert(amount, { currency: true, ignoreDecimal: true });
  return words;
};

const HotelInvoicePDF = ({ invoiceData }) => {
  if (!invoiceData) {
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <Text>No invoice data available.</Text>
        </Page>
      </Document>
    );
  }

const getBookingRef = (bookingData) => {
  return bookingData?.bookingId || 'TGH-HBK-0001';
};

const getInvoiceNumber = (bookingData) => {
  return bookingData?.invoiceNumber || 'TGH-INV-0001';
};

  const checkInDate = invoiceData?.checkIn
    ? new Date(invoiceData.checkIn).toLocaleDateString()
    : 'N/A';
  const checkOutDate = invoiceData?.checkOut
    ? new Date(invoiceData.checkOut).toLocaleDateString()
    : 'N/A';

  const paymentAmount = invoiceData?.amountPaid ?? 0;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <View style={styles.companySection}>
            <Image style={styles.logo} src={logo} />
            <Text style={styles.companyName}>The Great Himalayas Hotels</Text>
            <Text style={styles.companyDetails}>
              Siliguri, Darjiling(Dist), West Bengal, 734001{'\n'}
              GSTIN: 09AAHCH9024K1Z7{'\n'}
              Phone: +91 98835 87965 | Email: contact@thegreathimalayas.com
            </Text>
          </View>

      <View style={styles.invoiceInfo}>
            <Text style={{ ...styles.sectionTitle, marginTop: 0 }}>INVOICE</Text>
            <Text style={styles.companyDetails}>
              Invoice #: {getInvoiceNumber(invoiceData)}
              {'\n'}
              Booking Ref: {getBookingRef(invoiceData)}
              {'\n'}
              Date: {new Date().toLocaleDateString()}
            </Text>
          </View>
        </View>

        {/* Guest Information */}
        <Text style={styles.sectionTitle}>Guest Information</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={styles.tableColHeader}>Guest Name</Text>
            <Text style={styles.tableColHeader}>Contact</Text>
            <Text style={styles.tableColHeader}>Check-In</Text>
            <Text style={styles.tableColHeader}>Check-Out</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tableCol}>{invoiceData?.firstName} {invoiceData?.lastName}</Text>
            <Text style={styles.tableCol}>
              {invoiceData?.email}{'\n'}
              {invoiceData?.phone}
            </Text>
            <Text style={styles.tableCol}>{checkInDate}</Text>
            <Text style={styles.tableCol}>{checkOutDate}</Text>
          </View>
        </View>

{/*Property & Accommodation */}
<Text style={styles.sectionTitle}>Property & Accommodation</Text>

<View style={styles.table}>

  {/* Row 1 */}
  <View style={styles.tableRow}>
    <Text style={{ ...styles.tableCol, width: '33.33%' }}>
      <Text style={{ fontWeight: 'bold' }}>Property: </Text>
      {invoiceData?.propertyId?.propertyName || 'N/A'}
    </Text>

    <Text style={{ ...styles.tableCol, width: '33.33%' }}>
      <Text style={{ fontWeight: 'bold' }}>Phone: </Text>
      {invoiceData?.propertyId?.contact?.phone || 'N/A'}
    </Text>

    <Text style={{ ...styles.tableCol, width: '33.33%' }}>
      <Text style={{ fontWeight: 'bold' }}>Email: </Text>
      {invoiceData?.propertyId?.contact?.email || 'N/A'}
    </Text>
  </View>

  {/* Row 2 */}
  <View style={styles.tableRow}>
    <Text style={{ ...styles.tableCol, width: '100%', flexWrap: 'wrap' }}>
      <Text style={{ fontWeight: 'bold' }}>Address: </Text>
      {invoiceData?.propertyId?.location?.address || 'N/A'}, {' '}
      {invoiceData?.propertyId?.location?.city || ''}{' '}
      {invoiceData?.propertyId?.location?.pincode || ''} {'\n\n'}

      <Text style={{ fontWeight: 'bold' }}>Accommodation: </Text>
      {invoiceData?.accommodationId?.name || 'N/A'} {' | '}

      <Text style={{ fontWeight: 'bold' }}>Guests: </Text>
      {invoiceData?.guests || 'N/A'}
    </Text>
  </View>

</View>

        {/* Payment Details */}
        <Text style={styles.sectionTitle}>Payment Details</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={styles.tableColHeader}>Description</Text>
            <Text style={styles.tableColHeader}>Amount (₹)</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tableCol}>Room Charges</Text>
            <Text style={styles.tableCol}>{paymentAmount.toFixed(2)}</Text>
          </View>
        </View>

        <View style={styles.amountSection}>
          <View style={styles.totalAmount}>
            <Text style={{ fontWeight: 'bold' }}>GRAND TOTAL</Text>
            <Text style={{ fontSize: 14, marginTop: 4 }}>
              ₹ {paymentAmount.toFixed(2)}
            </Text>
            <Text style={{ fontSize: 8, marginTop: 4 }}>{convertToWords(paymentAmount)}</Text>
          </View>
        </View>

     <View style={styles.footer}>
  <Text>
    Thank you for choosing The Great Himalayas Hotels! {'\n'}

    • Cancellation Policy:{'\n'}
    100% refund if cancelled 72 hours before check-in • 
    50% refund if cancelled between 24 to 72 hours • 
    No refund within 24 hours of check-in {'\n'}

    • For queries: +91 98835 87965 | contact@thegreathimalayas.com {'\n'}
    • This is a computer generated invoice • Terms & Conditions apply
  </Text>
</View>

      </Page>
    </Document>
  );
};

export default HotelInvoicePDF;
